import React, { createContext, Component } from 'react';
import { getSave, saveGame } from '../util/game.util';

export const GameContext = createContext();

class Context extends Component {
    state = {
        save: getSave(),
        updateSave: (save) => {
            // console.log("old", this.state.save)
            // console.log("new", save)
            this.setState({ ...this.state.save, ...save }, () => {
                saveGame(this.state.save);
                // console.log("merged", this.state.save)
            });
        }
    };

    render() {
        return (
            <GameContext.Provider value={this.state}>
                {this.props.children}
            </GameContext.Provider>
        );
    }
}

export default Context;
